(ns frontend.view.modals.choice-confirmation.view
  (:require
   [common.localization :as loc]
   [frontend.view.modals.choice-confirmation.events :as events]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.components.radio-group.view :as radio-group]))

(defonce modal-key :choice-confirmation-modal)

(defn view
  [{:keys [state _shown? _close-modal! _props _topmost?]}]
  (events/reset-state! state)
  (fn [{:keys [state shown? close-modal! props topmost?]}]
    (let [{:keys [body title radio-text-yes radio-text-no cancel-text confirm-color confirm-icon confirm-text
                  on-confirm on-cancel accept-false? body-position]
           ;; defaults:
           :or   {title          (loc/tr :attention)
                  body-position  :top
                  radio-text-yes (loc/tr :i-understand-theres-no-undo-for-this)
                  radio-text-no  (loc/tr :i-understand-theres-no-undo-for-this)
                  cancel-text    (loc/tr :cancel)
                  confirm-color  ::c/danger
                  accept-false?  false
                  confirm-icon   [:i.fal.fa-trash-alt]
                  confirm-text   (loc/tr :delete)}} props
          confirmed? (:confirmed? @state)
          options [{:value true
                    :label radio-text-yes}
                   {:value false
                    :label radio-text-no}]]
      [modal/view
       {:visible?      (and shown? topmost?)
        :hide!         close-modal!
        :backdrop      "static"
        :close-button? true
        :color         confirm-color}
       title
       [:<>
        (when (= body-position :top)
          [:div
           body])

        ;;TIMO help needed here. Check logic for this radio
        [radio-group/view
         {:options     options
          :value       confirmed?
          :orientation :vertical
          :on-change   #(events/toggle-confirmed! state %)}]

        ;; [:div.zap-modal__body__row.pt-2
        ;;  [:label
        ;;   {:class-name "zap-inlined-radiobox-label mb-3"}
        ;;   [:input.delete-confirmation-modal__radiobox.zap-inlined-radiobox__green
        ;;    {:name      "zap-choice-confirmation-radio"
        ;;     :type      "radio"
        ;;     :checked   (or (false? confirmed?)
        ;;                    (and (not accept-false?)
        ;;                         (nil? confirmed?)))
        ;;     :value     (or (false? confirmed?)
        ;;                    (and (not accept-false?)
        ;;                         (nil? confirmed?)))
        ;;     :on-change #(events/toggle-confirmed! state false)}]
        ;;   radio-text-no
        ;;   [:span
        ;;    {:class-name "radiomark"}]]]

        ;; [:div.zap-modal__body__row
        ;;  [:label
        ;;   {:class-name "zap-inlined-radiobox-label"}
        ;;   [:input.delete-confirmation-modal__radiobox.zap-inlined-radiobox__green
        ;;    {:name      "zap-choice-confirmation-radio"
        ;;     :type      "radio"
        ;;     :checked   (or confirmed? "")
        ;;     :value     (or confirmed? "")
        ;;     :on-change #(events/toggle-confirmed! state true)}]
        ;;   radio-text-yes
        ;;   [:span
        ;;    {:class-name "radiomark"}]]]

        (when (= body-position :bottom)
          [:div
           {:class "mt-4 p-4 text-warning-light-text bg-warning-light border border-solid border-warning-light-border rounded"}
           body])]
       [:<>
        [:div
         {:class "flex gap-3"}
         [button/secondary-hollow
          {:on-click (fn [_]
                       (when (fn? on-cancel)
                         (on-cancel))
                       (close-modal!))}
          cancel-text]]
        [:div
         {:class "flex gap-3 justify-end"}
         (if (= confirm-color ::c/danger)
           [button/danger-solid
            {:icon      confirm-icon
             :disabled? (or (nil? confirmed?)
                            (and (not accept-false?)
                                 (not confirmed?)))
             :on-click  (fn [_]
                          (on-confirm (:confirmed? @state))
                          (close-modal!))}
            confirm-text]
           [button/primary-solid
            {:icon      confirm-icon
             :disabled? (or (nil? confirmed?)
                            (and (not accept-false?)
                                 (not confirmed?)))
             :on-click  (fn [_]
                          (on-confirm (:confirmed? @state))
                          (close-modal!))}
            confirm-text])]]])))
